(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('PolicyAnag', PolicyAnag);

    PolicyAnag.$inject = ['$resource'];

    function PolicyAnag ($resource) {
        var resourceUrl =  'api/anag-policies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            
            'update': { method:'PUT' },
            'findFieldNames': {
                method: 'GET',
                isArray: true,
                url: 'api/anag-policy-fields',
                transformResponse: function (data) {
                	if (data) {
                        data = angular.fromJson(data);
                        data = data.map(function(str, i) {return {fieldName: str}});
                    }
                    return data;
                }
            },
            'verify': {
                method: 'POST',
                url: 'api/verify-policy'
            },
            'create': {
                method: 'POST',
                url: 'api/create-anag-policy'
            },
            'activate': {
                method: 'POST',
                url: 'api/activate-anag-policy'
            }
        });
    }
})();
